module.exports = __webpack_public_path__ + "img/salsa_roja.d55160d2.jpg";